import ReactDOM from 'react-dom/client';

import App from './App';

import '@src/main/assets/styles/main.scss';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
